<template>
  <div>
    <images-dialog ref="imagesDialog" @submit="dialogSubmitted" />
    <image-edit-dialog
      ref="imageEditDialog"
      :key="value"
      @formSubmitted="fetchSelectedImage"
    />
    <div class="box">
      <img
        v-if="selectedImage"
        class="thumbnail"
        :src="src"
        :alt="selectedImage.title"
      />
      <div class="image-info">
        <p class="image-info__title" v-if="selectedImage">
          {{ selectedImage.title }}
          <i
            class="image-info__edit-image-icon fa fa-edit"
            @click="openEditImageDialog"
          />
        </p>
        <el-button @click="openDialog" type="info" class="open-dialog-button">
          <i class="fa fa-file-image-o"></i> Wybierz lub prześlij zdjęcie
        </el-button>
      </div>
      <el-button
        @click.stop="removeImage"
        class="remove-button"
        v-if="value"
        size="mini"
        icon="el-icon-delete"
        type="danger"
        title="Usuń zdjęcie"
      >
      </el-button>
    </div>
    <small v-if="help" class="field-info">{{ help }}</small>
  </div>
</template>
<script>
import ImagesDialog from '@/components/inputs/ImageDialog/'
import ImageEditDialog from '@/components/inputs/ImageDialog/ImageEditDialog'
import { Image } from '@/api'

export default {
  props: ['value', 'help'],
  components: {
    ImagesDialog,
    ImageEditDialog
  },
  data() {
    return {
      selectedImage: null
    }
  },
  methods: {
    removeImage() {
      this.$emit('input', null)
    },
    openDialog() {
      this.$refs.imagesDialog.openDialog()
    },
    dialogSubmitted(image) {
      this.$emit('input', image)
    },
    fetchSelectedImage() {
      Image.get({ id: this.value }).then(response => {
        this.selectedImage = response.data
      })
    },
    openEditImageDialog() {
      this.$refs.imageEditDialog.openDialog(this.value)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        value ? this.fetchSelectedImage() : (this.selectedImage = null)
      }
    }
  },
  computed: {
    src() {
      const thumbnail = this.selectedImage.thumbnail
      return thumbnail ? thumbnail.url : this.selectedImage.file_url
    }
  }
}
</script>
<style lang="scss" scoped>
.remove-button {
  position: absolute;
  right: 28px;
  top: 28px;
}

.open-dialog-button {
  vertical-align: middle;
}

.thumbnail {
  max-width: 140px;
  vertical-align: middle;
}

.image-info {
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;

  &__title {
    font-weight: 700;
  }

  &__edit-image-icon {
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>
